export default __webpack_public_path__ + "3af334d6f5ec0e505b75c0995d641763.svg";